import { OtherRevenueMode } from "@/types/otherRevenue";

export type RoomsData = {
  totalRoomsRevenue: number;
  roomsAvailableYearTotal: number;
};

export type OtherRevenueResults = {
  spaRevenue: number;
  otherRevenue: number;
  totalAncillary: number;
  ancillaryRevPAR: number;
};

export function calculateOtherRevenue(
  state: any,
  roomsData: RoomsData,
): OtherRevenueResults {
  let spaRevenue = 0;
  let otherRevenue = 0;

  if (state?.spa) {
    const treatmentsPerDay = Number(state.spa.treatmentsPerDay) || 0;
    const avgPrice =
      Number(state.spa.avgPrice) || Number(state.spa.avgPricePerTreatment) || 0;
    spaRevenue = treatmentsPerDay * 365 * avgPrice;
  }

  if (state?.wellness && spaRevenue === 0) {
    const treatmentsPerDay = Number(state.wellness.treatmentsPerDay) || 0;
    const avgPrice = Number(state.wellness.avgPrice) || 0;
    spaRevenue = treatmentsPerDay * 365 * avgPrice;
  }

  const otherMode = state?.other?.mode;

  if (otherMode === "percentage" || otherMode === "pctRooms") {
    let pct = 0;

    if (otherMode === "percentage") {
      pct = Number(state.other.percentageOfRooms) || 0;
    } else if (otherMode === "pctRooms") {
      pct = Number(state.other.value) || 0;
    }

    otherRevenue = (roomsData.totalRoomsRevenue || 0) * (pct / 100);
  } else if (otherMode === "fixed" || otherMode === "monthlyFixed") {
    let monthlyFixed = 0;

    if (otherMode === "fixed") {
      // FIX: fallback to .value if .monthlyFixed not set
      monthlyFixed =
        Number(state.other.monthlyFixed) || Number(state.other.value) || 0;
    } else if (otherMode === "monthlyFixed") {
      monthlyFixed = Number(state.other.value) || 0;
    }

    otherRevenue = monthlyFixed * 12;
  }

  const totalAncillary = spaRevenue + otherRevenue;
  const roomsAvailable = roomsData.roomsAvailableYearTotal || 0;
  const ancillaryRevPAR =
    roomsAvailable > 0 ? totalAncillary / roomsAvailable : 0;

  return {
    spaRevenue,
    otherRevenue,
    totalAncillary,
    ancillaryRevPAR,
  };
}

const modeConverter: Record<string, OtherRevenueMode> = {
  pctRooms: "percentage",
  percentage: "percentage",
  monthlyFixed: "fixed",
  fixed: "fixed",
};

export function convertMode(mode: string): OtherRevenueMode {
  return modeConverter[mode] || "percentage";
}
